import React from "react";

import Button from "@common/components/Button/Button";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { useUserFeedbackDiscardNewTicketModal } from "@main/pages/UserFeedback/views/UserFeedbackAddNewTicketView/useUserFeedbackDiscardNewTicketModal";

type UserFeedbackDiscardNewTicketModalProps = ReturnType<typeof useUserFeedbackDiscardNewTicketModal>;

export default function UserFeedbackDiscardNewTicketModal({
  DiscardNewTicketModal,
  discardNewTicketModalProps,
  onDiscardClick,
}: UserFeedbackDiscardNewTicketModalProps) {
  return (
    <DiscardNewTicketModal
      {...discardNewTicketModalProps}
      heading={`Discard ticket?`}
      buttonElement={
        <Button
          type="button"
          size="small"
          color="red"
          onClick={onDiscardClick}
        >
          {"Yes, discard"}
        </Button>
      }
    >
      <Paragraph>{"You have unsaved changes that will be lost."}</Paragraph>
    </DiscardNewTicketModal>
  );
}
